import React,{ useContext } from 'react';
// import image_settings from '../../image_settings.json';
// import settings from '../../settings.json';
import {StateAmbContext} from '../../stateContext';


function ImageLoader(props) {
  const { settings, image_settings } = useContext(StateAmbContext);

    var img_path = "";
    if (props.product === "cu_unit"){
        img_path = settings.image_path + image_settings.cu_img;
    }
    else if(props.product === "uc_unit"){
        img_path = settings.image_path +  image_settings.uc_img;
    }
    else if(props.product === "system_unit"){
        img_path = settings.image_path +  image_settings.system_img;
    }
    else{
        //other image paths can be used.
    }
    return (
        <img className="img-fluid" src={String(img_path)} />
    );
}

export default ImageLoader;